export const en = {
  title: "YunOcean - Enterprise Distributed Architecture ",
  welcome: "Welcome back, please login to your account.",
  login: "Login",
  username_email: "Username/Email Address",
  password: "Password",
  remember_me: "Remember me?",
  forgot_password: "Forgot Password?",
  dont_account: "Don't have an account?",
  create_account: "Create an Account",
  pwd: "pwd",
  join_us: "Join Yunocean",
  create_your_account: "Create your account",
  username: "Username",
  email_address: "邮箱地址",
  register: "Register",
  do_you_have_account: "Do you have an account?",

  //错误描述
  please_correct_errors: "Please correct the following error(s):",
  username_required: "Username required.",
  email_address_required: "Email required.",

  username_email_required: "Username/Email required.",
  valid_username_email_required: "Valid username/email required.",
  valid_email_required: "Valid email required.",
  valid_username_required: "Valid username required.",
  password_required: "Password required.",

  //忘记密码页面
  reset_your_password: "Reset your password",
  reset_password_detail: "Enter your user account's verified email address and we will send you a password reset link.",
  reset_your_email_address: "Enter your email address",
  reset_send_reset_email: "Send password reset email",

  // 页面找不到报错
  page_not_found: "Page Not Found!",
  page_not_found_detail: "The page you are looking for is currently not available , please try after some time or go back to home.",
  back_to_homne: "Back to Home"
}

export const zh = {
  title: "智能语音系统-让沟通更简捷",
  welcome: "欢迎回来，请登录到您的帐户",
  login: "登 录",
  username_email: "账号或邮箱地址",
  email_address: "邮箱地址",
  password: "密码",
  remember_me: "记住账号?",
  agree_info_security_book: "同意并已阅读《信息安全承诺书》",
  forgot_password: "忘记密码?",
  dont_account: "还没有帐户?",
  create_account: "创建一个帐户",
  pwd: "密码",
  join_us: "加入 YunOcean",
  create_your_account: "创建您的帐户",
  username: "用户名",
  register: "注 册",
  do_you_have_account: "你有没有账号?",

  //错误描述
  please_correct_errors: "请改正下面的错误:",
  username_required: "需要用户名.",
  email_address_required: "需要邮箱地址.",

  username_email_required: "需要帐户名或邮件地址.",
  valid_username_email_required: "需要有效的帐户名或邮箱地址.",
  valid_email_required: "需要有效的邮箱地址.",
  valid_username_required: "需要有效的用户名.",
  password_required: "需要密码.",

  //忘记密码页面
  reset_your_password: "重置你的密码",
  reset_password_detail: "输入您的用户帐户的已验证电子邮件地址，我们将向您发送密码重置链接。",
  reset_your_email_address: "输入你的邮箱地址",
  reset_send_reset_email: "发送密码重置电子邮件",

  // 页面找不到报错
  page_not_found: "页面不存在！",
  page_not_found_detail: "您要查找的页面当前不可用，请过一段时间再尝试或返回首页。",
  back_to_homne: "回到首页"
}



// WEBPACK FOOTER //
// ./src/i18n/module_lang/Auth_lang.js